$(function(){
    $('.paragraph-animation').each(function(){
        var el = this;
        var $el = $(this);
        var config = $el.data();
        lottie.loadAnimation({
            container: el,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            mode: 'bounce',
            path: `/wp-content/themes/dieste/resources/animations/${config.animation}.json`,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet'
            }
        });
    })
});